import * as React from 'react'

function SvgFaqFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 24.5c6.627 0 12-5.373 12-12S18.627.5 12 .5 0 5.873 0 12.5s5.373 12 12 12zm0-17.4a2.4 2.4 0 00-2.4 2.4 1.2 1.2 0 01-2.4 0 4.8 4.8 0 119.6 0c0 1.12-.286 1.997-.77 2.709-.46.678-1.058 1.137-1.51 1.476l-.09.067c-.448.336-.724.543-.93.8-.171.214-.3.476-.3.948a1.2 1.2 0 01-2.4 0c0-1.028.321-1.816.825-2.447.41-.512.937-.903 1.33-1.194l.125-.094c.448-.336.75-.59.965-.905.191-.282.355-.68.355-1.36A2.4 2.4 0 0012 7.1zm1.2 12a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgFaqFilled
